import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import { CheckboxOption, components, RadioOption } from '@atlaskit/select';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const resultsCountTextStyles = xcss({
  color: 'color.text.subtlest',
  fontSize: '0.75rem'
});
const descriptionTextStyles = xcss({
  color: 'color.text.subtlest',
  fontSize: '0.75rem'
});
const optionWrapperStyles = xcss({
  // Enable wrapping text within the option container
  whiteSpace: 'normal',
  color: 'color.text'
});
const optionSelectedStyles = xcss({
  color: 'color.text.selected'
});
const iconBeforeStyles = xcss({
  // Prevent the icon from shrinking when the sibling flex items are too wide
  flexShrink: 0
});
const iconAfterStyles = xcss({
  // Allow flex item to grow so we align it in the center of the remaining space
  flexGrow: 1
});
/**
 * Separate `Internal` component created for the custom UI, to make it easier to test.
 * `CustomOption` is passed to react select, and requires additional props that are
 * internally used by react select, so is difficult to test.
 */
export const CustomOptionInternal = _ref => {
  let {
    label,
    resultsCount,
    description,
    iconBefore,
    iconAfter,
    isSelected
  } = _ref;
  return /*#__PURE__*/_jsxs(Inline, {
    spread: "space-between",
    space: "space.100",
    alignBlock: "center",
    xcss: [optionWrapperStyles, isSelected && optionSelectedStyles],
    children: [/*#__PURE__*/_jsxs(Inline, {
      space: "space.100",
      alignBlock: "center",
      grow: "fill",
      children: [iconBefore && /*#__PURE__*/_jsx(Inline, {
        xcss: iconBeforeStyles,
        children: iconBefore
      }), /*#__PURE__*/_jsxs(Stack, {
        children: [/*#__PURE__*/_jsx(Box, {
          children: label
        }), description && /*#__PURE__*/_jsx(Box, {
          xcss: descriptionTextStyles,
          children: description
        })]
      }), iconAfter && /*#__PURE__*/_jsx(Inline, {
        alignInline: "center",
        xcss: iconAfterStyles,
        children: iconAfter
      })]
    }), resultsCount !== undefined && /*#__PURE__*/_jsxs(Box, {
      xcss: resultsCountTextStyles,
      children: ["[", resultsCount, "]"]
    })]
  });
};
const multiSelectDesktopStyles = xcss({
  paddingBlock: 'space.075'
});
const singleSelectDesktopStyles = xcss({
  paddingBlock: 'space.050'
});
const mobileWrapperStyles = xcss({
  paddingBlock: 'space.150'
});
const isMulti = props => props.selectProps.isMulti;
export const CustomOption = props => isMulti(props) ? /*#__PURE__*/_jsx(CheckboxOption, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx(Box, {
    xcss: multiSelectDesktopStyles,
    children: /*#__PURE__*/_jsx(CustomOptionInternal, _objectSpread({}, props.data))
  })
})) : /*#__PURE__*/_jsx(components.Option, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx(Box, {
    xcss: singleSelectDesktopStyles,
    children: /*#__PURE__*/_jsx(CustomOptionInternal, _objectSpread(_objectSpread({}, props.data), {}, {
      isSelected: props.isSelected
    }))
  })
}));
export const CustomOptionMobile = props => isMulti(props) ? /*#__PURE__*/_jsx(CheckboxOption, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx(Box, {
    xcss: mobileWrapperStyles,
    children: /*#__PURE__*/_jsx(CustomOptionInternal, _objectSpread({}, props.data))
  })
})) :
/*#__PURE__*/
/**
 * Type cast is required as RadioOption doesn't support generic types in the current version of @atlaskit/select
 * This will be cleaned up in DSP-17354, once @atlaskit/select is bumped
 */
_jsx(RadioOption, _objectSpread(_objectSpread({}, props), {}, {
  children: /*#__PURE__*/_jsx(Box, {
    xcss: mobileWrapperStyles,
    children: /*#__PURE__*/_jsx(CustomOptionInternal, _objectSpread({}, props.data))
  })
}));